import Vue from 'vue';
import VueRouter from 'vue-router';
import OptionPill from 'archive_search/option_pill';
import ArticleCard from 'archive_search/article_card';
import EventCard from 'archive_search/event_card';
import { debounce } from 'lodash';
import QSHandler from 'archive_search/query_string_handler';

import "core-js/stable";
import "regenerator-runtime/runtime";

const axios = require('axios');
const routes = [{ path: '*' }];

Vue.use(VueRouter);

const router = new VueRouter(routes);

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    router,
    data: {
      yearOptions: [],
      tagOptions: [],
      typeOptions: [],
      yearsSelected: [],
      tagsSelected: [],
      typesSelected: [],
      isPrefetched: false,
      searchResults: {}
    },
    methods: {
      preloadUrlVars(){
        let handler = new QSHandler(this.$route.query);
        this.yearsSelected = handler.extract('years');
        this.tagsSelected = handler.extract('tags');
        this.typesSelected = handler.extract('types');
      },
      attachWatchers(){
        app.$watch('typesSelected', () => { this.updateState(); });
        app.$watch('tagsSelected', () => { this.updateState(); });
        app.$watch('yearsSelected', () => { this.updateState(); });
      },
      updateState(){
        this.updateRoute();
        this.debouncedSendQuery();
      },
      configureUrlState() {
        this.preloadUrlVars();
        this.resetUrlVars();
        this.attachWatchers();
        this.updateState();
      },
      resetUrlVars(){ this.$router.push({query: {}}) },
      fetchOptions(){
        axios.get('/archive_searches.json').then((response) => {
          this.yearOptions = response.data.defaults.year_options;
          this.tagOptions = response.data.defaults.tag_options;
          this.typeOptions = response.data.defaults.type_options;
          this.configureUrlState();
        });
      },
      removeSelection(type, value) {
        var handler = new QSHandler(null);
        let idx = this[type+'Selected'].findIndex((e) => { return handler.formatForJs(e) === handler.formatForJs(value); });
        if (idx !== -1) {
          this[type+'Selected'].splice(idx,1);
        }
      },
      addSelection(type, value){
        var handler = new QSHandler(null);
        let idx = this[type+'Selected'].findIndex((e) => { return handler.formatForJs(e) === handler.formatForJs(value); });
        if (idx === -1) {
          this[type+'Selected'].push(handler.formatForJs(value));
        }
      },
      shouldQuery(){
        if (this.yearsSelected.length>0 ||
            this.tagsSelected.length>0 ||
            this.typesSelected.length>0) return true;

        this.searchResults = {};
        return false;
      },
      sendQuery(){
        if (this.shouldQuery()) {
          axios.get('/archive_searches/show.json', {
            params: {
              years: this.yearsSelected.map(year => { return decodeURIComponent(year); }),
              tags: this.tagsSelected.map((tag)=>{ return decodeURIComponent(tag); }),
              types: this.typesSelected.map((type)=>{ return decodeURIComponent(type); })
            }
          }).then((response) => {
            app.searchResults = response.data.results;
          });
        }
      },
      updateRoute(){
        this.$router.push({
          query: {
            'years[]': this.yearsSelected,
            'tags[]': this.tagsSelected,
            'types[]': this.typesSelected
          }
        });
      },
      yearsInclude(year){
        var handler = new QSHandler(null);
        return this.yearsSelected.includes(handler.formatForJs(year));
      },
      tagsInclude(tag){
        var handler = new QSHandler(null);
        return this.tagsSelected.includes(handler.formatForJs(tag));
      },
      typesInclude(type){
        var handler = new QSHandler(null);
        return this.typesSelected.includes(handler.formatForJs(type));
      },
    },
    computed: {
      totalResults(){ return this.searchResults.result_count; },
      newsResults(){ return this.searchResults.news; },
      eventResults(){ return this.searchResults.events; },
      industryResults(){ return this.searchResults.industry_applications; },
      newsResultsExist(){
        if (Array.isArray(this.searchResults.news)) {
          return this.searchResults.news.length;
        }
      },
      eventResultsExist(){
        if (Array.isArray(this.searchResults.events)) {
          return this.searchResults.events.length;
        }
      },
      industryResultsExist(){
        if (Array.isArray(this.searchResults.industry_applications)) {
          return this.searchResults.industry_applications.length;
        }
      },
    },
    components: {
      OptionPill,
      ArticleCard,
      EventCard
    },
    created(){
      this.debouncedSendQuery = debounce(this.sendQuery, 500);
    },
    mounted(){
      let csrfMetaTag = document.querySelector('meta[name=csrf-token]');
      axios.defaults.headers.common['X-CSRF-Token'] = csrfMetaTag.getAttribute('content');
      axios.defaults.headers.common['Content-Type'] = 'application/json';
      axios.defaults.headers.common['Accept'] = 'application/json';
      this.fetchOptions();
    }
  }).$mount('[data-js-archive-search]');
});
